<template>
    <app-layout title="Announcements">

        <page-header>
            <template #title>Announcements</template>

            <template #actions>
                <jet-button type="button" :href="route('announcements.create')" :disabled="form.processing" >
                    Add
                </jet-button>
            </template>
        </page-header>

        <div class="px-8">
            <div class="flex">
                <form class="flex flex-1 gap-x-2 flex-wrap" @submit.prevent="handleSubmit">
                    <!-- Search / Filters -->
                    <div class="flex flex-1 gap-x-2">
                        <div class="flex flex-col flex-1">
                            <jet-label for="search" value="Search" />
                            <jet-input type="text" class="h-7 text-base w-48" name="search" v-model="form.search" @input="handleSubmit" placeholder="Search..."/>
                        </div>
                    </div>
                </form>

                <div class="self-end">
                    <jet-tertiary-button type="button" class="py-1 ml-4 h-7" @click="handleReset" >
                        Reset
                    </jet-tertiary-button>
                </div>
            </div>
        </div>

        <div class="px-8 pt-2 pb-4">
            <div class="rounded-t overflow-hidden border border-b-0">
                <table class="table w-full" :class="{ 'table-with-links' : announcements.data.length }">
                    <thead>
                        <tr>
                            <th class="text-left">Message</th>
                            <th class="text-left whitespace-nowrap">Pricing Levels</th>
                            <th class="whitespace-nowrap">Last Updated</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="announcements.data.length">
                            <tr v-for="announcement in announcements.data" :key="announcement.id">
                                <td class="text-left">
                                    <Link class="block px-2 py-1 h-auto" :href="route('announcements.edit', announcement.id)">
                                        {{ announcement.message }}
                                    </Link>
                                </td>
                                <td class="text-left">
                                    <Link class="block px-2 py-1 h-auto" :href="route('announcements.edit', announcement.id)">
                                        {{ announcement.pricing_title ?? '-' }}
                                    </Link>
                                </td>
                                <td class="whitespace-nowrap">
                                    <Link class="block px-2 py-1 h-auto" :href="route('announcements.edit', announcement.id)">
                                        {{ formatedDate(announcement.updated_at) }}
                                    </Link>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="1" class="text-center p-8">No Announcements Found</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

            <pagination class="inline-flex" v-if="announcements.data.length" :links="announcements.links" />
        </div>
    </app-layout>
</template>

<script>
import { useForm, Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input';
import JetLabel from '@/Jetstream/Label';
import JetTertiaryButton from '@/Jetstream/TertiaryButton'
import Pagination from '@/Jetstream/Pagination';
import { DateTime } from "luxon";

export default {
    setup(props) {
        const form = useForm({
            search: props.filters.search,
        });

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetInput,
        JetLabel,
        JetTertiaryButton,
        Link,
        Pagination,
    },

    props: ['announcements', 'filters'],

    methods: {
        handleSubmit: _.debounce(function () {
            this.form.get(route('announcements.index'), { preserveState: true });
        }, 250),

        handleReset () {
            this.form.search = '';
            this.handleSubmit();
        },

        formatedDate (date) {
            if (!date) {
                return '';
            }

            return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED);
        },
    },
}
</script>

<style scoped>

</style>
